import { render } from "./BuyerApprovedCancelOrder.vue?vue&type=template&id=5701649d&scoped=true"
import script from "./BuyerApprovedCancelOrder.vue?vue&type=script&lang=js"
export * from "./BuyerApprovedCancelOrder.vue?vue&type=script&lang=js"

import "./BuyerApprovedCancelOrder.vue?vue&type=style&index=0&id=5701649d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5701649d"]])

export default __exports__